import StudentTaskPanel from './StudentTaskPanel';

export default StudentTaskPanel;
